import React, {useCallback, useEffect} from "react";
import { useAccountStore } from "../zustand/account";
import { LoadingOverlay } from '@mantine/core';


export default function LogMeOutPage() {

    const { userStatus, logUserOut} = useAccountStore();

    const GridBackground = () => {
        return (
            <div style={{ position: "fixed", left: 0, top: 0, bottom: 0, zIndex: -1, width: "100%", height: "100vh", backgroundImage: 'url("/image/background-grid.png")', backgroundAttachment: "fixed" }}></div>

        )
    } 

    const handleLogoutClick = useCallback(() => {
      return Promise.resolve(logUserOut()).then(() => window.location.replace('https://mbxr.io/login'))
    }, [logUserOut])
 

    useEffect(() => {
        userStatus === "loggedIn-none" ?  handleLogoutClick() :
        userStatus === "loggedOut" ?  window.location.replace('https://mbxr.io/login') : window.location.replace('https://mbxr.io/projects')
    },[handleLogoutClick, userStatus])

    return (
        <div>
            <GridBackground />
                <LoadingOverlay loaderProps={{ color: 'black' }} visible={true} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
        </div>
    )
}